<!--底部内容-->
<template>
  <div class="footer">
    <p>
      <el-link type="info" :underline="false" class="link-default" @click="aboutUs">关于我们</el-link>
      <el-link type="info" :underline="false" class="link-default" @click="merchantCenter">商家中心</el-link>
      <el-link type="info" :underline="false" class="link-default" @click="serviceAgreement">服务协议</el-link>
      <el-link type="info" :underline="false" class="link-default" @click="privacyPolicy">隐私政策</el-link>
    </p>
    <p class="el-describe">
      <el-link type="info" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11000002000100"
               :underline="false" class="link-info">渝公网安备&nbsp;11000002000100号
      </el-link>&emsp;
      <el-link type="info" href="http://beian.miit.gov.cn" :underline="false" class="link-info">渝ICP备1541704号</el-link>
      <br/>Copyright&nbsp;©&nbsp;2004&nbsp;-&nbsp;2021&emsp;帮企科技集团&nbsp;版权所有
    </p>
    <vxe-modal v-model="dialog1" width="600" :showHeader="false" transfer mask-closable show-close>
      <template #default>
        <div class="dialog">
          <vxe-button type="text" icon="fa vxe-icon--close" class="close-btn" title="关闭" @click="dialog1=false"/>
          <about-us/>
        </div>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
import Vue from 'vue';
import AboutUs from "@/views/personal/aboutUs";
import VXETable from 'vxe-table';
import 'vxe-table/lib/index.css';
import {personal} from "@/api/interfaceApi";
Vue.use(VXETable)
export default {
  name: "index",
  components: {AboutUs},
  data(){
    return{
      dialog1:false,
      CustomInfo:{},
      cid:0,
    }
  },
  methods:{
    /*关于我们*/
    aboutUs(){
      this.dialog1=true;
    },
    /*服务协议*/
    serviceAgreement(){
      window.open('https://customerservice.bangqichat.com/index/agreement/article?aWQ9MjE=', '_blank')
    },
    /*商家中心*/
    merchantCenter(){
      let that=this;
      if (JSON.stringify(that.CustomInfo)=='{}'){
        that.$alert('您还没有登录,是否进行登录', {
          confirmButtonText: '确定',
          callback: action => {
            that.$router.replace({
              path: '/login'
            })
          }
        })
      }else{
        personal({
          bid:that.CustomInfo.cid,
          cid:that.CustomInfo.cid
        }).then(res=>{
          if (res.code==200){
            if (res.content.shopId==0 || res.content.shopId==null || res.content.shopId==undefined){
              that.$alert('您的账号未开通店铺，请先认证企业再开通店铺', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  let routeData = that.$router.resolve({
                    name: "enterpriseCertification",
                    path: '/officialCloud/enterpriseCertification',
                  });
                  window.open(routeData.href, '_blank')
                }
              });
            }
          }else{
            /*跳转店铺详情*/
            let routeData = that.$router.resolve({
              name: "shop",
              path: '/storeManagement/shop',
              query: {
                id: res.content.shopId,
                pName: that.cityList.abridge + '企服务云'
              }
            });
            window.open(routeData.href, '_blank')
          }
        })
      }
    },
    /*隐私政策*/
    privacyPolicy(){
      window.open('https://customerservice.bangqichat.com/index/agreement/article?aWQ9MjA=', '_blank')
    },
  },
  mounted() {
    this.CustomInfo=sessionStorage.getItem('CustomInfo') ? sessionStorage.getItem('CustomInfo') : {};
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
  }
}
</script>

<style scoped lang="scss">
.footer {
  background: center;
  position: fixed;
  bottom: 0px;
  z-index: 9999;
  padding: 10px;
  text-align: center;
  width: 100%;

  .link-default {
    margin-right: 15px;
    color: #333;
    font-weight: bold;
  }

  .el-describe {
    font-size: 14px;
    color: #333333;
    line-height: 22px;

    .link-info {
      font-size: 14px;
      color: #333;
      vertical-align: baseline;
    }
  }
}
</style>